import * as tslib_1 from "tslib";
import { Router } from '@angular/router';
import { OAuthService, JwksValidationHandler } from 'angular-oauth2-oidc';
import { SettingsService } from '../../settings';
import { DBkeys } from '../../settings';
import { Profile } from './models/profile.model';
import { BehaviorSubject } from 'rxjs';
import { LocalStoreManager } from '../../shared/services/local-store-manager.service';
export class LoginService {
    constructor(oAuthService, settingsService, router, localStorage) {
        this.oAuthService = oAuthService;
        this.settingsService = settingsService;
        this.router = router;
        this.localStorage = localStorage;
        this.hasValidAcessTokenAndExpiredInnetExp = false; //fix very specific error/case
        this._userProfile = new BehaviorSubject(null);
        this.userProfile$ = this._userProfile.asObservable();
        this.settings = settingsService.get();
        // https://tfs.cap-hpi.tools/DefaultCollection/International/_search?type=code&lp=custom-Project&text=appSettings.useAuthentication&result=DefaultCollection%2FInternational%2F%24%2FInternational%2F664%2F%24%2FInternational%2FBranches%2FBI_MB%2FPublic%2FApplications%2FCapHpi.BulkValuations%2Fsrc%2FCapHpi.BulkValuations.Web%2Fsrc%2Fapp%2Fauth%2Fservices%2Fauth.service.ts&preview=1&filters=ProjectFilters%7BInternational%7D&_a=search
        // https://tfs.cap-hpi.tools/DefaultCollection/International/_search?type=code&lp=custom-Project&text=appSettings.useAuthentication&result=DefaultCollection%2FInternational%2Fbulk-valuations%2FGBmaster%2F%2Fsrc%2FCapHpi.BulkValuations.Web%2Fsrc%2Fapp%2Fauth%2Fservices%2Fauth.service.ts&preview=0&filters=ProjectFilters%7BInternational%7D&_a=search
        if (this.settings.useIdentityServer) {
            this.configureAuth().then(() => {
                this.trylogin();
            });
        }
    }
    configureAuth() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // window.location.origin,//throw exception on IE 10
            let localUrl = /*window.location.origin || */ this.settings.appUrl;
            const authConfig = {
                issuer: this.settings.identityServerUrl,
                redirectUri: localUrl,
                silentRefreshRedirectUri: localUrl + '/silent-refresh.html',
                clientId: 'CapHpi.Applications.ResidualTracker.Web2',
                scope: 'openid profile email Cap.User.Organisation',
                oidc: true,
            };
            //this.oAuthService.skipIssuerCheck = true; //to fix error main.05152f64b2085655e6ea.js:1 invalid issuer in discovery document expected: https://dv1-identity.cap-hpi.com/ current: https://dv1-identity.cap-hpi.com
            this.oAuthService.configure(authConfig);
            this.oAuthService.tokenValidationHandler = new JwksValidationHandler();
            ////this.oAuthService.sessionChecksEnabled = true;
            ////start: need init if we don't use loadDiscoveryDocument...() 
            //this.oAuthService.loginUrl = (this.settings.identityServerUrl + '/connect/authorize'),
            //this.oAuthService.tokenEndpoint = (this.settings.identityServerUrl + '/identity/connect/token');
            //this.oAuthService.logoutUrl = (this.settings.identityServerUrl + '/connect/endsession');
            //this.oAuthService.sessionCheckIFrameUrl = (this.settings.identityServerUrl + '/connect/checksession');
            //this.oAuthService.userinfoEndpoint = (this.settings.identityServerUrl + 'identity/connect/userinfo');
            ////this.oAuthService.jwksUri = (this.settings.identityServerUrl + '/.well-known/jwks');
            //////this.oAuthService.discoveryDocumentLoaded = true;
            //this.oAuthService.tokenValidationHandler = null;// new JwksValidationHandler();//skip token validation, because we don't use loadDiscoveryDocument...() ;
            ////end: need init if we don't use loadDiscoveryDocument...() 
            //vt//
            this.oAuthService.events.subscribe(e => this.processEvents(e));
            this.oAuthService.setStorage(localStorage);
        });
    }
    trylogin() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            //this.oAuthService.setupAutomaticSilentRefresh();
            //this.oAuthService
            //  .silentRefresh()
            //  .then(info => console.debug('refresh ok', info))
            //  .catch(err => console.error('refresh error', err));
            //await this.oAuthService.loadDiscoveryDocumentAndTryLogin();
            yield this.oAuthService.loadDiscoveryDocumentAndLogin();
            //await this.oAuthService.loadDiscoveryDocument();
            if (this.isLoggedIn) { //on login callback// page refresh
                this.oAuthService.setupAutomaticSilentRefresh(); //move event here 20.12.2019
                this.lastRequestedUrl = this.loadLocalStore(DBkeys.CALL_BACK_URL);
                this.deleteData(DBkeys.CALL_BACK_URL);
                //console.log('LoginService, trylogin(), this.isLoggedIn = true, login callback', this.lastRequestedUrl);
                const claims = this.oAuthService.getIdentityClaims();
                var profile;
                var profileEntity;
                if (this.oAuthService.discoveryDocumentLoaded) {
                    profile = yield this.oAuthService.loadUserProfile();
                }
                if (profile) {
                    profileEntity = new Profile(profile.email, profile.given_name, profile.family_name, profile.organisation_id);
                }
                else {
                    profileEntity = new Profile("", "", "", "");
                }
                this._userProfile.next(profileEntity);
                //console.log("profile details", profile);
                if (claims && claims['exp' /*Expiration Time*/] && claims['iat' /*Issued At*/]) {
                    var now = new Date();
                    var nowEpoch = Math.round(now.getTime() / 1000);
                    var exp = new Date(0);
                    exp.setUTCSeconds(claims['exp']);
                    //console.log("expire after mins: " + (claims['exp'] - nowEpoch) / 60 + ", token active mins: " + (claims['exp'] - claims['iat']) / 60 + ", exp " + exp + ", now " + now);
                }
                if (this.lastRequestedUrl && this.router.url !== this.lastRequestedUrl) {
                    this.router.navigateByUrl(this.lastRequestedUrl);
                    this.lastRequestedUrl = null;
                }
                if (pendo) {
                    pendo.initialize({
                        visitor: {
                            id: profile.sub,
                        },
                        account: {
                            id: profile.organisation_id,
                        }
                    });
                }
            }
        });
    }
    login() {
        //this.oAuthService.initLoginFlow();
        this.oAuthService.initImplicitFlow();
    }
    logout() {
        this._userProfile.next(null);
        this.oAuthService.logOut();
    }
    get isLoggedIn() {
        if (!this.settings.useIdentityServer) {
            return true;
        }
        var token = this.oAuthService.getAccessToken();
        const isValid = this.oAuthService.hasValidAccessToken();
        //test with expired token
        const isValidId = this.oAuthService.hasValidIdToken();
        const idTokenExpiration = this.oAuthService.getIdTokenExpiration();
        const accessTokenExpiration = this.oAuthService.getAccessTokenExpiration();
        const now = new Date();
        var timeNow = now.getTime();
        //console.log(this.hasValidAcessTokenAndExpiredInnetExp, "timeNow", timeNow, "accessTokenExpiration", accessTokenExpiration, "idTokenExpiration", idTokenExpiration);
        if (accessTokenExpiration && accessTokenExpiration < timeNow) {
            //console.log("hasValidAccessToken (accessTokenExpiration)", false);
            return false;
        }
        if (idTokenExpiration && idTokenExpiration < timeNow) {
            //console.log("getIdTokenExpiration (idTokenExpiration)", false);
            return false;
        }
        if ( /*!this.hasValidAcessTokenAndExpiredInnetExp &&*/token && isValid) {
            return true;
        }
        return false;
    }
    accessToken() {
        return this.oAuthService.getAccessToken();
    }
    //from Leeds code
    //https://tfs.cap-hpi.tools/DefaultCollection/International/_git/user-management?path=%2FCapHpi.UserManagement.Web%2Fsrc%2Fapp%2Fauth-module%2Fservices%2Flogin.service.ts&version=GBmaster&_a=contents
    ensureLoggedIn(callBackUrl) {
        return new Promise((resolve, reject) => {
            if (!this.isLoggedIn) {
                this.oAuthService.loadDiscoveryDocument()
                    .then(() => {
                    this.oAuthService.tryLogin({}); // This method just tries to parse the token(s) within the url when
                    // the auth-server redirects the user back to the web-app
                    // It doesn't send the user to the login page.
                    if (!this.oAuthService.hasValidAccessToken()) { // Does the user need to login?
                        if (callBackUrl) {
                            this.saveToLocalStore(callBackUrl, DBkeys.CALL_BACK_URL);
                        }
                        this.oAuthService.initImplicitFlow(); // This will redirect away from page
                        console.log('LoginService, ensureLoggedIn(), this.isLoggedIn = false, initImplicitFlow() redirect');
                        return; // returning to prevent promise resolution when redirect takes place
                    }
                    else {
                        console.log('LoginService, ensureLoggedIn(), this.isLoggedIn = false, loadDiscoveryDocument() resolved');
                        resolve(true);
                    }
                    this.oAuthService.setupAutomaticSilentRefresh();
                });
            }
            else {
                if (!this.settings.useIdentityServer) {
                    resolve(true);
                }
                if (!this.oAuthService.hasValidAccessToken()) { // Is the user token valid?
                    this.oAuthService.initImplicitFlow(); // Go Get A New Token
                    return; // returning to prevent promise resolution when redirect takes place
                }
                console.log('LoginService, ensureLoggedIn(), this.isLoggedIn = true, loadDiscoveryDocument() resolved');
                resolve(true);
            }
        });
    }
    processEvents(event) {
        //console.log("oauth2-oidc processEvents: " + event.type, event, new Date());
        switch (event.type) {
            case 'token_received':
                {
                    let test = 'received';
                    // https://stackoverflow.com/questions/51761306/angular-oauth2-oidc-how-to-detect-if-i-logged-in-somewhere-else/51780984
                    //this.checkLoginState();
                }
                break;
            case 'silent_refresh_timeout':
            case 'silent_refresh_error':
                {
                    //this.oAuthService.initImplicitFlow();// refresh failed: make user login again
                    //console.log(event);
                    //alert('silent_refresh_error');
                    let test = 'error';
                }
                break;
            case 'silently_refreshed':
                {
                    let test = 'refreshed';
                }
                break;
            case 'token_validation_error':
                {
                    let test = 'error';
                    this.hasValidAcessTokenAndExpiredInnetExp = true;
                }
                break;
            case 'discovery_document_load_error':
                {
                    let test = 'error';
                }
                break;
            case 'discovery_document_loaded':
                {
                    let test = 'loaded';
                }
                break;
            case 'logout':
                {
                    let test = 'logout';
                }
                break;
        }
        if (event.type === 'silent_refresh_error') { // refresh failed: make user login again
            this.oAuthService.initImplicitFlow();
        }
    }
    storeLastRequestedUrl(callBackUrl) {
        this.saveToLocalStore(callBackUrl, DBkeys.CALL_BACK_URL);
    }
    deleteData(key) {
        if (this.localStorage.exists(key))
            return this.localStorage.deleteData(key);
    }
    loadLocalStore(key) {
        if (this.localStorage.exists(key))
            return this.localStorage.getDataObject(key);
    }
    saveToLocalStore(data, key) {
        setTimeout(() => this.localStorage.savePermanentData(data, key));
    }
}
